import React from 'react'
import { connect } from 'react-redux';
import { Modal } from 'antd';
import { localization } from '../../Utils/Localization/localization';
import { UploadPhoto } from '../Routes/Pages/AddProductPage/UploadPhoto';
import { IPhoto } from '../../Utils/types';

interface StateProps { }
interface DispatchProps { }
interface Props extends StateProps, DispatchProps {
  language: string,
  visible: boolean,
  img: IPhoto
  handleSubmit: () => void,
  updatePhoto: (file: any) => void,
  handleClose: () => void
}

function UpdatePhoto(props: Props) {
  return (
    <Modal
      title={localization('uploadPhoto', props.language)}
      visible={props.visible}
      onOk={props.handleSubmit}
      onCancel={props.handleClose}
    >
      <UploadPhoto
        handleSubmit={props.handleSubmit}
        img={props.img}
        language={props.language}
        uploadPhoto={props.updatePhoto}
      />
    </Modal>
  );
}

function mapStateToProps(state: any) {
  return {}
}
const mapDispatchToProps = {}

const ConnectedUpdatePhoto = connect(mapStateToProps, mapDispatchToProps)(UpdatePhoto);
export { ConnectedUpdatePhoto as UpdatePhoto };